import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeaderBackground = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Vrstva_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 605.4 610",
	style: { enableBackground: "new 0 0 605.4 610" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.st0{fill:#ED6A25;}\n	.st1{fill:#085877;}\n	.st2{fill:#55BEC3;}\n"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M302.49,304.54L605.4,0H4.81C3.03,0,2.13,2.15,3.39,3.41L302.49,304.54z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M301.78,305L605.4,610V0L301.78,305z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st2",
			d: "M302.49,304.54L0,610h605.4L302.49,304.54z"
		})
	]
});
export default SvgHeaderBackground;
